import { toast } from '@kalos/ui';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { getBatchUserQueryConfig } from '../../hooks/react-query/useUserQuery';
import { useFieldLayout } from '../../hooks/useMedia';
import { techniciansUserFilter } from '../../modules/ComponentsLibrary/Pickers/newPickers/utils';
import { SpiffTool } from '../../modules/SpiffToolLogs/components/SpiffTool';
import { ToolLogOwnerPhone } from '../../modules/ToolFundDashboard/phone/ToolLogOwnerPhone';

export const Route = createFileRoute('/toolLog/$toolLogOwnerId')({
  component: RouteComponent,
  params: z.object({
    toolLogOwnerId: z.coerce.number().positive(),
  }),
  async loader(ctx) {
    const employees = await ctx.context.queryClient.ensureQueryData(
      getBatchUserQueryConfig(techniciansUserFilter),
    );
    const employee = employees?.results.find((el) => el.id === ctx.params.toolLogOwnerId);
    if (!employee) {
      toast({
        variant: 'destructive',
        title: `Employee not found for tool log (ID: ${ctx.params.toolLogOwnerId})`,
      });
      throw redirect({ to: '/home' });
    }
    return { employee };
  },
  head(ctx) {
    return {
      meta: [
        {
          title: `Tool Log - ${ctx.loaderData.employee.firstname} ${ctx.loaderData.employee.lastname}`,
        },
      ],
    };
  },
});

function RouteComponent() {
  const { toolLogOwnerId } = Route.useParams();
  const { employee } = Route.useLoaderData();
  const isFieldLayout = useFieldLayout();
  if (isFieldLayout) {
    return (
      <ToolLogOwnerPhone
        ownerId={toolLogOwnerId}
        ownerName={`${employee.firstname} ${employee.lastname}`}
      />
    );
  }
  return <SpiffTool type="Tool" disableActions ownerId={toolLogOwnerId} />;
}
